"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadGoogleApi = exports.computeDistanceBetween = void 0;
// istanbul ignore file: doesn't hold any logic
const GoogleApi_1 = __importStar(require("./GoogleApi"));
Object.defineProperty(exports, "computeDistanceBetween", { enumerable: true, get: function () { return GoogleApi_1.computeDistanceBetween; } });
Object.defineProperty(exports, "loadGoogleApi", { enumerable: true, get: function () { return GoogleApi_1.loadGoogleApi; } });
exports.default = GoogleApi_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZ29vZ2xlLWFwaS9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLCtDQUErQztBQUMvQyx5REFBK0U7QUFzQnRFLHVHQXRCVyxrQ0FBc0IsT0FzQlg7QUFBRSw4RkF0QlcseUJBQWEsT0FzQlg7QUFFOUMsa0JBQWUsbUJBQVMsQ0FBQyJ9